"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const applicationStateConstants_1 = __importDefault(require("./applicationStateConstants"));
const applicationStateBuildReducer = (defaultValues) => {
    const defaultState = {
        runningMode: defaultValues.runningMode,
        openInputDialog: undefined,
        openAlert: undefined,
        openAdMobInterstitialAds: undefined,
        sideMenuContext: {
            isOpened: false,
        },
        bottomMenuFlagsByPage: {},
        customFontName: defaultValues.customFontName,
        openImageViewer: {
            urls: undefined,
            isOpened: false,
        },
    };
    return (propState, action) => {
        var _a, _b, _c, _d, _e;
        const state = propState || defaultState;
        switch (action === null || action === void 0 ? void 0 : action.type) {
            case applicationStateConstants_1.default.RESET:
                return defaultState;
            case applicationStateConstants_1.default.UPDATE_RUNNING_MODE:
                return Object.assign(Object.assign({}, state), { runningMode: action.payload });
            case applicationStateConstants_1.default.UPDATE_INPUTDIALOG_CONTEXT:
                return Object.assign(Object.assign({}, state), { openInputDialog: action.payload });
            case applicationStateConstants_1.default.UPDATE_ALERT_CONTEXT:
                return Object.assign(Object.assign({}, state), { openAlert: action.payload });
            case applicationStateConstants_1.default.UPDATE_CONFIRM_ALERT_CONTEXT:
                return Object.assign(Object.assign({}, state), { openConfirmAlert: action.payload });
            case applicationStateConstants_1.default.UPDATE_ADMOB_INTERSTITIAL_CONTEXT:
                return Object.assign(Object.assign({}, state), { openAdMobInterstitialAds: action.payload });
            case applicationStateConstants_1.default.SET_IS_BOTTOM_MENU_OPENED: {
                const currentFlag = !!((_a = state.bottomMenuFlagsByPage) === null || _a === void 0 ? void 0 : _a[action.payload.pageId]);
                const newFlag = action.payload.flag;
                if (newFlag === currentFlag) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { bottomMenuFlagsByPage: Object.assign(Object.assign({}, state.bottomMenuFlagsByPage), { [action.payload.pageId]: newFlag }) });
            }
            case applicationStateConstants_1.default.SET_IS_SIDE_MENU_OPENED:
                return Object.assign(Object.assign({}, state), { sideMenuContext: {
                        isOpened: action.payload || !((_b = state.sideMenuContext) === null || _b === void 0 ? void 0 : _b.isOpened),
                    } });
            case applicationStateConstants_1.default.SET_TRANSITION_SIDE_MENU:
                return Object.assign(Object.assign({}, state), { sideMenuContext: {
                        isOpened: !!((_c = state.sideMenuContext) === null || _c === void 0 ? void 0 : _c.isOpened),
                        transition: (_d = action.payload) === null || _d === void 0 ? void 0 : _d.type,
                        speed: (_e = action.payload) === null || _e === void 0 ? void 0 : _e.speed,
                    } });
            case applicationStateConstants_1.default.SET_CUSTOM_FONT_NAME: {
                return Object.assign(Object.assign({}, state), { customFontName: action.payload });
            }
            case applicationStateConstants_1.default.OPEN_IMAGE_VIEWER: {
                return Object.assign(Object.assign({}, state), { openImageViewer: action.payload });
            }
            default:
                return state;
        }
    };
};
exports.default = applicationStateBuildReducer;
